<template>
  <v-container>
    <h2>Role information</h2>
    <v-row>
      <v-col lg="10" md="12" xs="12">
        <v-row>
          <v-col
            cols="4"
            md="2"
          >
            <p>Role name:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ role.role_name || '-' }}</p>
          </v-col>
        </v-row>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'role-list' }"
          >
            Back
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "RoleView",
  components: { },
  data: () => ({
    role: {
      id: null,
      role_name: null
    },
  }),
  async mounted () {
    this.role.id = this.$route.params.id
    await this.getRole()
  },
  methods: {
    async getRole () {
      try {
        const { data } = await this.$http.get(`/back-office/roles/${this.role.id}`, authHeader())
        this.role.role_name = data.role_name
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    }
  },
};
</script>
